import {
  createRootRoute,
  Outlet,
  redirect,
  useLocation,
} from '@tanstack/react-router';
import { Layout } from '../components/Layout';
import { useAuthStore } from '../store/auth.store';
import { isTokenExpired } from '../lib/session';

const PUBLIC_PATHS = ['/login', '/verify', '/accept-invite', '/check-email'];

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const { sessionToken, clear } = useAuthStore.getState();
    if (isTokenExpired(sessionToken)) {
      if (sessionToken) clear();
      if (!PUBLIC_PATHS.includes(location.pathname)) {
        throw redirect({ to: '/login' });
      }
    }
  },
  component: RootComponent,
});

function RootComponent() {
  const { pathname } = useLocation();
  if (PUBLIC_PATHS.includes(pathname)) return <Outlet />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
